import { alpha, darken, lighten, styled } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";

const getHoverBackgroundColor = (color: string, mode: string) =>
  mode === "dark" ? lighten(color, 0.5) : darken(color, 0.5);

const defaultStyles = {
  border: 0,
  //   minHeight: "407px",
  //   "& .MuiDataGrid-columnHeaders": {
  //     borderWidth: "thick",
  //     fontWeight: 700,
  //   },
  "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
    outline: "none !important",
  },
  "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus": {
    outline: "none !important",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal",
    lineHeight: "normal",
  },
  "& .MuiDataGrid-columnHeader": {
    // Forced to use important since overriding inline styles
    height: "unset !important",
  },
  "& .MuiDataGrid-columnHeaders": {
    borderWidth: "thick",
    fontWeight: 700,
    // Forced to use important since overriding inline styles
    maxHeight: "168px !important",
  },
};

export const SMDataGrid = styled(DataGridPro)(({ theme }) => {
  const errorColor = alpha(theme.palette.error.main, 0.08);
  return {
    ...defaultStyles,
    "& .datagrid-row-error": {
      backgroundColor: errorColor,
      "&:hover": {
        backgroundColor: getHoverBackgroundColor(errorColor, theme.palette.mode),
      },
    },
    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
      backgroundColor: theme.palette.mode === "light" ? "#F8F9FA" : "#1E1E1E0A",
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
      borderRadius: 8,
      backgroundColor: theme.palette.mode === "light" ? "#CED4DA" : "#6b6b6b",
      minHeight: 24,
      border: theme.palette.mode === "light" ? "2px solid #F8F9FA" : "2px solid #1E1E1E",
    },
    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
      backgroundColor: "#959595",
    },
    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
      backgroundColor: "#959595",
    },
    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#959595",
    },
    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
      backgroundColor: "#2b2b2b",
    },
  };
}) as typeof DataGridPro;

(SMDataGrid as any).defaultProps = {
  density: "comfortable",
};
